import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
const AdminAdvertBlock = ({ title, section, onRemove }) => {
  return (
    <Card>
      <Card.Body>
        <Row className="align-items-center">
          <Col sm={9}>
            <Card.Title>Advert Title: {title}</Card.Title>
            <Card.Text>Advert Location: {section}</Card.Text>
          </Col>
          <Col sm={3}>
            <div className="">
              <Button
                variant="danger"
                onClick={onRemove}
                className="mr-2 addbtn"
              >
                Remove
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default AdminAdvertBlock;
